import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div style={{ minHeight:"100vh", display:"grid", placeItems:"center", background:"#f6f8fa", padding:24 }}>
      <div style={{ background:"#fff", border:"1px solid #e5e7eb", borderRadius:16, padding:24, maxWidth:480, textAlign:"center" }}>
        <div style={{ fontSize:48, fontWeight:800, color:"#0f172a" }}>404</div>
        <div style={{ marginTop:8, fontSize:18, fontWeight:700 }}>Page not found</div>
        <p style={{ color:"#475569" }}>
          The link you followed may be broken or the page may have moved.
        </p>
        <div style={{ display:"flex", gap:10, justifyContent:"center" }}>
          <Link to="/" style={{ textDecoration:"none", padding:"10px 14px", border:"1px solid #e5e7eb", borderRadius:10, background:"#fff" }}>
            ← Home
          </Link>
          <Link to="/register" style={{ textDecoration:"none", padding:"10px 14px", borderRadius:10, background:"#0f766e", color:"#fff", fontWeight:700 }}>
            Register
          </Link>
        </div>
      </div>
    </div>
  );
}
